export default "/static/dashboard/build/app/img/v2/121988db95df59f2e84d51898ce9e3cc.png";